module.exports = __webpack_public_path__ + "static/media/cqe-logo-circle.a2163006.png";